module.exports = __webpack_public_path__ + "img/spinnerWhiteHorizontal.958f7796.svg";